exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".ant-progress-line.ant-progress-status-success .ant-progress-bg {\n  background-color: #1dcea9; }\n\n.ant-progress-line.ant-progress-status-success .ant-progress-text {\n  margin-left: 0.4em;\n  width: 2.34em;\n  color: #545454; }\n  .ant-progress-line.ant-progress-status-success .ant-progress-text:after {\n    content: \"100%\"; }\n\n.ant-progress-line.ant-progress-status-success .anticon {\n  display: none;\n  color: #1dcea9; }\n\n.ant-progress-line.ant-progress-status-normal .ant-progress-text {\n  color: #545454; }\n\n.ant-progress-line.ant-progress-status-normal .ant-progress-inner {\n  background-color: #e7e7e7; }\n\n.ant-progress-line.ant-progress-status-normal .ant-progress-bg {\n  background-color: #6cbaff; }\n\n.ant-progress-line.ant-progress-status-normal .anticon {\n  color: #6cbaff; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/lib/loader.js!./client/modules/core/Progress/ProgressBar/style.scss
// module id = 1040
// module chunks = 0